var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._b({class:`status-chip${_vm.largeSize ? '' : ' small'}`,attrs:{"ripple":false}},'v-chip',_vm.$attrs,false),[_c('span',[_vm._v(_vm._s(_vm.chipText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }